import { getFileExtension } from "../../../../utils/appUtils";

export const getUploadValidationError = (
  inputFile,
  supportedUploadExtensions,
  maxUploadFileSize,
) => {
  if (!inputFile) {
    return "ValueStrings.validFile";
  }

  const extension = getFileExtension(inputFile?.name || "");

  if (!supportedUploadExtensions.includes(extension)) {
    return "fileUpload.invalidFileType";
  }

  if (inputFile.size > maxUploadFileSize) {
    return "fileUpload.fileTooLarge";
  }

  return "";
};

export const getUploadedFileCards = ({ uploadedFiles }) => {
  const normalizedUploadedFiles = Array.isArray(uploadedFiles)
    ? uploadedFiles
    : [];

  if (normalizedUploadedFiles.length) {
    return normalizedUploadedFiles.map((uploadedFile, index) => ({
      id: `${uploadedFile?.plant_file_id || index}`,
      fileName: uploadedFile?.file_name,
      sheets: Array.isArray(uploadedFile?.sheets)
        ? uploadedFile.sheets.map((sheet) => ({
            sheetName: sheet?.sheet,
            trainNums: Array.isArray(sheet?.train_nums) ? sheet.train_nums : [],
          }))
        : [],
    }));
  }

  return [];
};
